import { en } from "./en";

export const it: typeof en = {
  level: "Livello",
  readMore: "Leggi di più",
  search: "Cerca",
  back: "Indietro"
};
